import { Validator } from '@vista-digital/validator';
export const carouselNumberOrAutoValidator = Validator.any([
    Validator.number(),
    Validator.isEqualTo('auto')
]);
export const carouselSettingsValidator = Validator.object({
    slidesToScroll: carouselNumberOrAutoValidator,
    watchDrag: Validator.optional(Validator.boolean()),
    dragFree: Validator.optional(Validator.boolean()),
    loop: Validator.optional(Validator.boolean()),
    duration: Validator.optional(Validator.number({ min: 20, max: 60 })),
    breakpoints: Validator.optional(Validator.object({}))
});
//# sourceMappingURL=settings.js.map